module.exports = __webpack_public_path__ + "static/pdr_hero-be9421bad611080f060519c8a6bb6f55.png";